// Button styles for the Activity log, matching the console's "Create New" button (components/header): red, rounded,
// shadowed, with an icon. Secondary actions use the same shape in the page's dark border colour.
const BASE =
  'inline-flex h-[34px] items-center justify-center gap-2 rounded-lg px-4 text-sm font-medium text-white shadow-md transition whitespace-nowrap disabled:cursor-not-allowed disabled:opacity-60';

export const PRIMARY_BUTTON = `${BASE} bg-red-700 hover:bg-red-800`;

export const SECONDARY_BUTTON = `${BASE} border border-[#474646] bg-[#1a1a1a] hover:bg-[#262626]`;
